// extracted by mini-css-extract-plugin
export default {"box":"index_box_2FEBy","box2":"index_box2_3cpcQ","logo":"index_logo_VtWX0","nav":"index_nav_VIi0S"};